const upsellSelectors = {
    modal: document.getElementById('cartUpsellModal'),
    container: document.querySelector('#cartUpsellModal [data_upsell_product]')
  };
  
  class cartUpsellJS {
    constructor() {
      
    }
  
    hideUpsellProduct(result){
      document.querySelectorAll("[data_upsell-item]").forEach(function(i,v){
        i.classList.remove("d-none");
      });
      result.forEach(function(y,z){
        document.querySelectorAll("[data_upsell-item='" + y.handle + "']").forEach(function(i) {
          i.classList.add("d-none");
        });
      });
    }
  
    upsellProduct(result) {
      this.hideUpsellProduct(result);    
      let html = '';
      let temp_html="";
      result.forEach((i, v)=>{
        let price = 0;
        price = Shopify.formatMoney(i.price, window.globalVariables.money_format);
        var product_title = i.product_title , newProductTitle ;
        if (product_title.includes('Auto')) {
          newProductTitle = product_title.replace('15.00% Off Auto renew', '');
        } else {
          newProductTitle = i.product_title;
        }
        temp_html = `<div class="col-12 col-md-6 p-2">
          <div class="border p-3 h-100 border-secondary d-flex align-items-center cart-item">
                <a class="my-0 text-danger close-cart-btn" href="javascript:void(0)" title="Remove" name="Remove" aria-label="Remove" data-toggle="tooltip" data-upsellRemove data-index="${v}" data-placement="left">
                    <i class="icon-close"></i>
              </a>
          <div class="d-flex align-items-center w-100">
            <div class="cart-img me-3">
                <img class="img-fluid item-img" style="min-width: 87px;width:87px;" src="${i.image}" alt="${i.title}" loading="lazy" width="75" height="75">
            </div>
            <div class="cart-item-text w-100">
              <a href="${i.url}" class="card-title h6 mb-0 me-2 text-capitalize">${newProductTitle}</a>
              <ul class="list-unstyled"></ul> 
              <p class="product-option"></p>
              <div class="d-flex align-items-center justify-content-between">
                  <div class="cart-total-price mt-2">${price}</div>
                    <div class="quantity-wrapper mt-2" data-qty-container="">
                    <a href="javascript:void(0)" class="btn-increase" data-upsellQty data-index="${v}" rel="nofollow" aria-label="Increase quantity for ${i.product_title}" title="Increase quantity for ${i.product_title}" data-for="increase" data-qty-btn="" data-upsell_product-type="${i.product_type}">
                      <i class="icon-sm-arrow-top"></i>
                      <span class="visually-hidden">Increase quantity for ${i.product_title}</span>
                    </a>
                    <input type="text" data-upsell-quantity name="quantity" aria-label="Quantity for ${i.product_title}" value="${i.quantity}" step="1" min="1" inputmode="numeric" data-qty-input="" class="quantity form-control fw-bold text-secondary border-secondary ps-3 h-100" readonly="">
                    <a href="javascript:void(0)" class="btn-decrease" rel="nofollow" data-upsellQty data-index="${v}" aria-label="Decrease ${i.product_title}" title="Decrease quantity for ${i.product_title}" data-for="decrease" data-qty-btn="" data-upsell_product-type="${i.product_type}">
                      <i class="icon-sm-arrow-bottom"></i>
                      <span class="visually-hidden">Decrease quantity for ${i.product_title}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>`;
        html = html + temp_html;
      });
      if(upsellSelectors.container){
        upsellSelectors.container.innerHTML = `<div class="row m-n2">${html}</div>`; 
        upsellSelectors.modal.querySelector('.modal').classList.add('open');
        siteOverlay.prototype.showOverlay();
        this.bindEvents();
      }
    }
    
    updateQuantity(variantId, quantitySymbol) {
      let currentTarget = event.currentTarget;
      let quantity = event.currentTarget.parentNode.querySelector("[data-upsell-quantity]").value;
      quantity = parseInt(quantity);
      if(quantitySymbol == "plus" ){
        quantity = quantity + 1;
        event.currentTarget.parentNode.querySelector("[data-upsell-quantity]").value =quantity;
        updateUpsell(variantId,quantity);
  
      }else if(quantitySymbol=="minus" && quantity != 1){
        quantity = quantity - 1;
        event.currentTarget.parentNode.querySelector("[data-upsell-quantity]").value =quantity;
        updateUpsell(variantId,quantity);
      }
    }
    
    bindEvents(){
      let qtyBtns = document.querySelectorAll('[data-upsellQty]');
      let removeBtns = document.querySelectorAll('[data-upsellRemove]');
      let ajaxCartEle = document.querySelector('ajax-cart');
      
      qtyBtns.forEach((Btn)=> {
        Btn.addEventListener('click', (event)=>{
          let currentTarget = event.currentTarget;
          let line = parseInt(currentTarget.dataset.index) + 1;
          let qtyContainer = currentTarget.closest('[data-qty-container]');
          let qtyInput = qtyContainer.querySelector('[name="quantity"]');
          let qty = parseInt(qtyInput.value);
          
          if(currentTarget.classList.contains('btn-increase')){
            qty = qty + 1;
          }else if(qty > 1){
              qty = qty - 1;
          }
          
          ajaxCartEle.updateItemQty(line, qty);
        });
      });
  
      removeBtns.forEach((Btn)=> {
        Btn.addEventListener('click', (event)=>{
          let currentTarget = event.currentTarget;
          let line = parseInt(currentTarget.dataset.index) + 1;
          ajaxCartEle.updateItemQty(line, 0);
        });
      });
    }
  }
  
  window.onload = () => {
      typeof cartUpsellJS !== 'undefined' && new cartUpsellJS();
  }
